import { type AppConfig, httpClient } from '@inpart-io/devtools';

import { trackOtherConfig } from '../config';

export type Headers = Record<string, string>;

export interface ITrackObject {
    id: string;
}

export interface TrackParameters {
    filter?: Record<string, string | string[]>;
    limit?: number;
    page?: number;
    search?: string;
    sort?: Record<string, 'ASC' | 'DESC'>;
}

interface TrackProcessedParameters {
    filter?: string;
    limit?: number;
    page?: number;
    search?: string;
    sort?: string;
}

export interface SearchResponse<T> {
    data: T[];
    limit: number;
    page: number;
    total: number;
}

export abstract class TrackObjectsManager<T extends ITrackObject = ITrackObject> {
    private readonly appConfig: AppConfig;
    private readonly urlObjectTypeContext: string;

    protected constructor(appConfig: AppConfig, objectTypeContext: string) {
        this.appConfig = appConfig;
        this.urlObjectTypeContext = objectTypeContext;
    }

    protected get url(): string {
        return `${this.appConfig.webappBaseUrl}${this.appConfig.webappContext}api/${this.urlObjectTypeContext}`;
    }

    public async search(params: TrackParameters = {}): Promise<SearchResponse<T>> {
        const _params: TrackProcessedParameters = {};
        if (params.filter) {
            _params.filter = JSON.stringify(params.filter);
        }
        if (params.limit) {
            _params.limit = params.limit;
        }
        if (params.page) {
            _params.page = params.page;
        }
        if (params.search) {
            _params.search = params.search;
        }
        if (params.sort) {
            _params.sort = JSON.stringify(params.sort);
        }
        return httpClient.get<SearchResponse<T>>(this.url, { params: _params, headers: { 'x-tenant-id': trackOtherConfig.tenant } });
    }
}
